'use client'

import {useCallback} from 'react'

import {Routes} from '@/src/config/routes'

import type {LoginBeginData, LoginFormData} from '@/src/features/auth/core/login-types'

import {useErrorReporter} from '@/src/shared/hooks/useErrorReporter'
import {useLoading} from '@/src/shared/hooks/useLoading'
import {useNotification} from '@/src/shared/hooks/useNotification'
import {getClient} from '@/src/shared/utils/api-factory'

export const useRequestOtp = () => {
  const loading = useLoading()
  const notifications = useNotification()
  const errorReporter = useErrorReporter()

  const requestOtp = useCallback(
    async (data: LoginFormData, captchaToken: string): Promise<(LoginBeginData & {phone: string}) | null> => {
      try {
        loading.start()
        const client = getClient('api')
        const loginData = await client.post<LoginBeginData>(Routes.api.auth.login.receiveCode, {
          data: {
            ...data,
            captcha_token: captchaToken,
          },
        })

        return {interval: loginData.interval, phone: data.phone!}
      } catch (e: unknown) {
        if (e instanceof Error) {
          notifications.error(e.message.replace(/API:\[\d+]:/, ''))
        } else {
          notifications.error(String(e))
        }
        errorReporter.capture(e)
        return null
      } finally {
        loading.stop()
      }
    },
    [loading, notifications, errorReporter],
  )

  return {loading, requestOtp}
}
